import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import { useNavigate } from 'react-router-dom';
import EditCantact from './components/EditContact';
// import { Form }from 'antd'

import { useDispatch, useSelector } from 'react-redux';

import {
  hobbies_list,
  sports_list,
  maritialStatus,
  createAboutme,
  countryCodes,
  get_byID
  // occupationData,
  // familyStatus,
  // familyValue,
  // familyType,
  // siblings_maritial_Status,
  // education_list,
  // department_list,
  // cities_list,
  // signup
} from './redux/slice';
import { pageview } from '../../utilities/gtag';

const index = () => {
  useEffect(() => {
    document.title = 'Contact information - Update contact details';
  }, []);
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    country_codes,
    // Occupation_Data,
    maritial_Status,
    // family_Status,
    // family_Value,
    // family_Type,
    // siblings_maritialStatus,
    get_hobbies_list,
    get_sports_list
    // education_details,
    // department_details,
    // city_details
  } = useSelector((state) => state.editprofile);

  const { user_data } = useSelector((state) => state.listDashboard);

  useEffect(() => {
    get_hobbies();
    get_sports();
    get_maritialStatus();
    get_listby_id();
    get_countryCodes();
    // get_occupation();
    // get_familyStatus();
    // get_familyValue();
    // get_familyType();
    // get_siblings_maritialStatus();
    // get_education_details();
    // get_department_details();
    // get_cities();
  }, []);

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userId = matUserObject.user_details.id;

  const get_listby_id = () => {
    const payload = userId;
    dispatch(get_byID(payload));
  };

  const get_hobbies = () => {
    const payload = { type: 'hobby' };
    dispatch(hobbies_list(payload));
  };
  const get_sports = () => {
    const payload = { type: 'sport' };
    dispatch(sports_list(payload));
  };
  const get_maritialStatus = () => {
    const payload = { type: 'user' };
    dispatch(maritialStatus(payload));
  };
  const get_countryCodes = () => {
    dispatch(countryCodes());
  };

  const onsubmit = async (values) => {
    console.log('onsubmit', values);
    // dispatch(createAboutme(payload));

    // const payload = formData;
    const payload = {
      height_ft: values.height_ft,
      height_in: values.height_in,
      is_disabled:
        values.is_disabled === '' ? false : Boolean(values.is_disabled),
      marital_status_id: values.marital_status_id,
      hobby_interests: values.hobby_interests.map((id) => ({
        hobby_sport_id: id
      })),
      sport_interests: values.sport_interests.map((id) => ({
        hobby_sport_id: id
      })),
      other_interests: values.other_interests,
      self_description: values.self_description
    };
    // dispatch(createAboutme(payload)
    try {
      console.log('Form Submitted:', payload);
      const response = await dispatch(createAboutme(payload)).unwrap(); // Dispatch Redux action
      if (response?.success) {
        localStorage.setItem('profile_id', response.profile_id); // Store profile ID
        navigate(`/editfamily/${response.profile_id}`); // Redirect on success
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <>
      <Layout sider={true}>
        <EditCantact
          get_hobbies_list={get_hobbies_list}
          get_sports_list={get_sports_list}
          maritial_Status={maritial_Status}
          country_codes={country_codes}
          onsubmit={onsubmit}
          user_data={user_data}
        />
      </Layout>
    </>
  );
};

export default index;
